/*
 * @Author: kongxiangyu
 * @Date: 2022-11-24 11:44:54
 * @LastEditTime: 2022-12-06 12:09:42
 * @email: kongxiangyu@cd.baidu.com
 * @Description: 入口文件
 */

import Vue from 'vue';
import App from './container/App.vue';
import router from './router';
import VueLazyload from 'vue-lazyload';
import fastclick from 'fastclick';
import {ErrorLoading, Toast} from '@baidu/map-mui';
import {Loading} from '@baidu/onemap-design';
import debounce from './constant/debounce';
import './constant/haotianjing';
import EventBus from './constant/EventBus';

// 公共样式文件
import '@/common/style/reset.scss';
import '@/common/style/base.scss';
Loading.install(Vue);
Toast.install(Vue);
ErrorLoading.install(Vue);


Vue.use(debounce);



Vue.use(VueLazyload, {
    preLoad: 1.8,
    listenEvents: ['scroll', 'transitionend']
    // error: '', //请求失败后显示的图片
    // loading: '', //加载的loading过渡图片
    // attempt: 1 // 加载图片数量
});
router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    next();
});

// 登录后的重载
// window.signin = num => {
//     if (parseInt(num, 10) === 1) {
//         setTimeout(() => {
//             EventBus.$emit('jointLogin');
//         }, 1000);
//     }
// };

// 初始化fastclick
fastclick.attach(document.body, {});

Vue.config.productionTip = false;

new Vue({
    router,
    // store,
    render: h => h(App)
}).$mount('#app');
